import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { AuthLayout } from "../components/AuthLayout";
import { LoginForm } from "../components/LoginForm";
import { RegisterForm } from "../components/RegisterForm";
import { RegistrationSuccess } from "../components/RegistrationSuccess";
import { useAuth } from "../hooks/useAuth";

export function LoginPage() {
  const { isAuthenticated, googleAuth, error, clearError } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const [registrationEmail, setRegistrationEmail] = useState<string | null>(
    null,
  );

  // Redirect if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleGoogleAuth = async () => {
    try {
      clearError();
      await googleAuth();
      // Redirect will happen automatically via auth state change
    } catch (error) {
      // Error is handled by AuthContext
      console.error("Google auth error:", error);
    }
  };

  const handleLoginSuccess = () => {
    // Navigation will happen automatically via auth state change
  };

  const handleRegistrationSuccess = (email: string) => {
    setRegistrationEmail(email);
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  const handleTermsClick = () => {
    // TODO: Open terms modal or navigate to terms page
    window.open("https://www.go2url.me/terms", "_blank");
  };

  const handlePrivacyClick = () => {
    // TODO: Open privacy modal or navigate to privacy page
    window.open("https://www.go2url.me/privacy", "_blank");
  };

  const getTitle = () => {
    if (registrationEmail) return "Registration Successful";
    return activeTab === "login" ? "Welcome Back" : "Create Account";
  };

  const getDescription = () => {
    if (registrationEmail) return "";
    return activeTab === "login"
      ? "Sign in to your account to continue"
      : "Create your account to get started";
  };

  if (registrationEmail) {
    return (
      <RegistrationSuccess 
        email={registrationEmail} 
        onBackToLogin={() => setRegistrationEmail(null)}
      />
    );
  }

  return (
    <AuthLayout title={getTitle()} description={getDescription()} error={error}>
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 mb-6">
          <TabsTrigger value="login">Sign In</TabsTrigger>
          <TabsTrigger value="register">Register</TabsTrigger>
        </TabsList>

        <TabsContent value="login" className="space-y-0">
          <LoginForm
            onSuccess={handleLoginSuccess}
            onForgotPassword={handleForgotPassword}
            onGoogleAuth={handleGoogleAuth}
          />
        </TabsContent>

        <TabsContent value="register" className="space-y-0">
          <RegisterForm
            onSuccess={handleRegistrationSuccess}
            onTermsClick={handleTermsClick}
            onPrivacyClick={handlePrivacyClick}
          />
        </TabsContent>
      </Tabs>
    </AuthLayout>
  );
}

